import moment from 'moment';
import { ReactNode } from 'react';
import { DateTimeStr, Timestamp } from '../types';

export async function copyToClipboard(text: string) {
  try {
    await navigator.clipboard.writeText(text);
  } catch (err) {
    console.error('Failed to copy text: ', err);
  }
}

export function copyToClipboardFormatted(text: string) {
  const processedText = text
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/p>/gi, '\n')
    .replace(/<p[^>]*>/gi, '')
    .trim();

  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(processedText).catch((err) => {
      console.warn('Failed to copy using Clipboard API:', err);
      copyToClipboard(processedText);
    });
  } else {
    copyToClipboard(processedText);
  }
}
export const isAudioDataEmpty = (data: any[]) => !data.find((value) => value !== 0);

export function flattenObject(obj: any, target?: any, prefix?: string) {
  target = target || {};
  prefix = prefix || '';

  Object.keys(obj).forEach(function (key) {
    if (typeof obj[key] === 'object') {
      flattenObject(obj[key], target, prefix + key + '.');
    } else {
      return (target[prefix + key] = obj[key]);
    }
  });

  return target;
}

export function getLocationMapsURL(lat: string, lng: string) {
  return `https://www.google.com.ar/maps?q=${lat},${lng}`;
}

export function renderMaybeFn<T = object>(
  node: ReactNode | ((props: T) => ReactNode),
  props?: T,
): ReactNode {
  if (!node) {
    return null;
  }

  if (typeof node === 'function') {
    return node(props!);
  }

  return node;
}

export function repeatFn(times: number, fn: (index: number) => any) {
  return Array.from({ length: times }).map((_, index) => fn(index));
}

export function debugTime(time: number | string | DateTimeStr | Timestamp | Date) {
  return moment(time).format('HH:mm:ss.SSS');
}
